export default __webpack_public_path__ + "static/media/landing-hero-image-macbook.d6a41f5c.png";